import type { TxErrorInfo } from '../tx-engine/types.js';

/**
 * Wrap a failed `SubmissionResult.error` in an `Error` that preserves the
 * structured fields the frontend's global mutation-error funnel resolves
 * (`resolve-api-error` rung 1 reads `userMessageKey`). Throwing a bare
 * `Error(string)` strips these, so the funnel falls through to
 * `errors.unknown` and the user sees a generic "something went wrong" toast
 * instead of the specific contract reason.
 */
export function txSubmitError(
  summary: string,
  error: TxErrorInfo,
  diagnostics?: Record<string, unknown>,
): Error {
  return Object.assign(new Error(summary), {
    name: 'TxError',
    code: error.code,
    stage: error.stage,
    traceId: error.traceId,
    recoveryAction: error.recoveryAction,
    userMessageKey: error.userMessageKey,
    morfiError: error.morfiError,
    details: error.details,
    diagnostics,
  });
}
